import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal, NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {StorageService} from '../../shared/services/storage.service';
import {StudentService} from '../../shared/services/student.service';
import {SessionService} from '../../shared/services/session.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'ps-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent implements OnInit {
  submitting: any = false;
  addSessionForm: FormGroup;
  modalType: any;
  isDisabled = true;
  user: any;
  students: any;
  sessions: any = [];

  constructor(private fb: FormBuilder,
              config: NgbPaginationConfig,
              private router: Router,
              private modalService: NgbModal,
              private studentService: StudentService,
              private title: Title,
              private sessionService: SessionService
  ) {
    config.size = 'sm';
    config.boundaryLinks = true;
    this.user = StorageService.getItem('self');
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.addSessionForm = this.fb.group({
      session_id: ['', Validators.required],
    });
    this.get();
    this.getSession();
  }

  getSession() {
    this.sessionService.get({'status': 'ACTIVE'}).subscribe(data => {
      if (data && data['data'].length > 0) {
        this.sessions = data['data'];
        if (this.sessions && this.sessions.length > 0) {
          this.patchSessionForm();
        }
      }
    });
  }

  patchSessionForm() {
    let currentSession = {};
    this.sessions.forEach(session => {
      if (session && session['session_default']) {
        currentSession = session;
      }
    });
    if (currentSession) {
      this.addSessionForm.patchValue({
        'session_id': currentSession['id']
      });
    }
  }

  get() {
    this.studentService.detail().subscribe(data => {
      if (data) {
        this.students = data;
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  submit() {
    this.modalType = 'ADD';
  }

  update() {
    this.modalType = 'UPDATE';
  }

  openLg(content) {
    this.modalService.open(content, {size: 'md'});
  }

  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }
  goToLink(url: any) {
    window.open(url, '_blank');
  }
}
